module.exports = __webpack_public_path__ + "static/media/puzzlepiece3.e08e070b.svg";